export default "__VITE_ASSET__43eeaf64__"